import React from 'react'
import {useApi} from "@src/hooks/useApi"
import {GetActiveBilling} from "@src/services/api-client"
import {Card, Loading} from "@therms/atalaya"
import dayjs from "dayjs"


export function ActiveSitesViewer(){
    const { data, isCalling } = useApi(GetActiveBilling)
    return (
        <Card className="mb-4">
            <div className="mb-base overflow-x-auto">
                <Loading overlay visible={isCalling}/>
                <table className="w-full text-color-neutral" style={{minWidth: 700}}>
                    <thead>
                        <tr className="font-bold whitespace-nowrap">
                            <td className="pr-4 pb-1">Billed To</td>
                            <td className="pr-4 pb-1">Email</td>
                            <td className="pr-4 pb-1"># of Sites</td>
                            <td className="pr-4 pb-1">Per Site Rate</td>
                            <td className="pr-4 pb-1">Est. Monthly Total</td>
                            <td className="pr-4 pb-1">Next Billing Date</td>
                            <td className="pb-1">Paid By</td>
                        </tr>
                    </thead>
                    <tbody>
                        {(data || []).map((item) => (
                            <tr key={item.email} className="italic">
                                <td className="pr-4 pb-1">{item.organizationName}</td>
                                <td className="pr-4 pb-1">{item.email}</td>
                                <td className="pr-4 pb-1">{item.siteIds.length}</td>
                                <td className="pr-4 pb-1">$ {(item.perSiteRateCents / 100).toFixed(2)}</td>
                                <td className="pr-4 pb-1">$ {(item.totalRateCents / 100).toFixed(2)}</td>
                                <td className="pr-4 pb-1">{dayjs(item.nextBillingDate).format('MM/DD/YYYY')}</td>
                                <td className="pb-1">{item.paymentSource === 'CreditCard' ? 'Credit Card' : 'Invoice'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Card>)}
